import { estabelecimento } from "../../Estabelecimento/estabelecimento"
import { confirmarPedido } from "../../mobile"
import { createElement, loginMessage, track } from "../../utils"

// Ganhe Pontos
// Acumule pontos em compras elegíveis (verificar condições).

// Troque por Recompensas
// Use seus pontos para resgatar produtos ou descontos (verificar disponibilidade).

export const telaCadastroFidelidade = (callback) => {
  const wrapper = createElement('div', { class: 'absolute bg-dark-overflow flex inset-0 items-end p-8 z-index-max' })
  wrapper.innerHTML = `
    <div class="bg-white flex flex-column gap-16 h-max rounde u-p-32 w-100" style="
      background: #fbfbfb;
      border-radius: 2rem;
      max-width: 420px;
      margin: auto;
    ">
      <div class="flex-column gap-24">
        <div class="flex flex-column gap-8">
          <h2 class="text-24">Você já é cadastrado no programa de fidelidade?</h2>
          <p class="font-14">Acumule pontos e troque por recompensas incríveis!</p>
        </div>
        <div class="flex flex-column gap-16">
          <div class="bg-white border border-1 flex flex-center flex-start gap-16 p-8 rounded-md">
            <svg style="color: var(--blue);" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-coins-icon lucide-coins"><circle cx="8" cy="8" r="6"></circle><path d="M18.09 10.37A6 6 0 1 1 10.34 18"></path><path d="M7 6h1v4"></path><path d="m16.71 13.88.7.71-2.82 2.82"></path></svg>
            <div class="flex flex-column">
              <p class="font-14 font-500">Ganhe Pontos</p>
              <div>
                <div class="font-12">Acumule pontos em compras elegíveis.</div>
                <div class="font-10 text-gray-300">Verificar condições.</div>
              </div>
            </div>
          </div>
          <div class="flex flex-center flex-start gap-16 border border-1 p-8 rounded-md shadow-sm">
            <svg style="color: var(--blue);" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-gift-icon lucide-gift"><rect x="3" y="8" width="18" height="4" rx="1"></rect><path d="M12 8v13"></path><path d="M19 12v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7"></path><path d="M7.5 8a2.5 2.5 0 0 1 0-5A4.8 8 0 0 1 12 8a4.8 8 0 0 1 4.5-5 2.5 2.5 0 0 1 0 5"></path></svg>
            <div class="flex flex-column">
              <p class="font-14 font-500">Troque por Recompensas</p>
              <div>
                <div class="font-12">Use seus pontos para resgatar produtos ou descontos.</div>
                <div class="font-10 text-gray-300">Verificar disponibilidade.</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex flex-column gap-8">
          <button class="btn-azul w-100">Entrar ou Cadastrar</button>
          <button class="btn-transparent w-100" style="
            border: 0;
            height: 40px;
          ">Não tenho interesse</button>
        </div>
      </div>
    </div>
  `

  const buttonSim = select('.btn-azul', wrapper)
  const buttonNao = select('.btn-transparent', wrapper)

  buttonSim.addEventListener('click', () => {
    track('cadastro', {
      tipo: 'cadastro',
      estabelecimento: estabelecimento.urlServer,
    })
    window.location.href = window.location.origin + '/Account/LoginPage?urlRef=' + estabelecimento.urlEmpresa + '&cadastrarFideliza=' + true
    wrapper.remove()
  })

  buttonNao.addEventListener('click', () => {
    track('sem-interesse', {
      tipo: 'cadastro',
      estabelecimento: estabelecimento.urlServer,
    })
    localStorage.setItem('sem-interesse-fideliza', true)
    loginMessage(confirmarPedido)
    wrapper.remove()
  })

  document.body.appendChild(wrapper)
}
